<template>
  <div>
    <div class="ucard-container">
      <div class="ucard-container-card">
        <div class="card-display">
          <img src="@/assets/imgs/home/2@3x.png" alt="UCard" class="ucard-image" />
        </div>
        <div class="card-description">
          <div class="network-info">
            <span class="network-label">{{ $t('virtualCardOneModule.label') }}</span>
          </div>
          <div class="title">{{ $t('virtualCardOneModule.title') }}</div>
          <div class="features">
            <div class="feature-item" v-for="(feature, index) in $t('virtualCardOneModule.subTitleList')" :key="index">
              <img :src="feature.img" alt="UCard"/>
              <div class="feature-content">
                <div class="feature-title">{{ feature.title }}</div>
                <div class="feature-detail">{{ feature.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ucard-container-two">
      <div class="title">
        <h1>{{ $t('virtualCardTwoModule.title') }}</h1>
      </div>
      <div class="card-group">
        <div class="card-one card-item">
          <h1>{{ $t('virtualCardTwoModule.cardGroup[0].name') }}</h1>
          <div class="content">
            <p>{{ $t('virtualCardTwoModule.cardGroup[0].descList[0].content') }}</p>
            <p>{{ $t('virtualCardTwoModule.cardGroup[0].descList[1].content') }}</p>
            <p>{{ $t('virtualCardTwoModule.cardGroup[0].descList[2].content') }}</p>
          </div>
        </div>
        <div class="card-two card-item">
          <h1>{{ $t('virtualCardTwoModule.cardGroup[1].name') }}</h1>
          <div class="content">
            <p>{{ $t('virtualCardTwoModule.cardGroup[1].descList[0].content') }}</p>
            <p>{{ $t('virtualCardTwoModule.cardGroup[1].descList[1].content') }}</p>
            <p>{{ $t('virtualCardTwoModule.cardGroup[1].descList[2].content') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container-three">
      <div class="title">
        <h1>{{ $t('virtualCardThreeModule.title') }}</h1>
      </div>
      <div class="features">
        <div class="feature-item" v-for="(feature, index) in $t('virtualCardThreeModule.openMgtList')" :key="index">
          <div class="feature-content">
            <div class="feature-title">{{ feature.title }}</div>
            <div class="feature-detail">{{ feature.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container-four">
      <div class="title">
        <h1>{{ $t('virtualCardFourModule.title') }}</h1>
      </div>
      <div class="feature-item" v-for="(feature, index) in $t('virtualCardFourModule.privacyAndSecurityList')" :key="index">
        <img :src="feature.img" alt="UBPay" class="item-img"/>
        <div class="feature-content">
          <div class="feature-title">{{ feature.title }}</div>
          <div class="feature-detail">{{ feature.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "VirtualCard",
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {

  },
};
</script>

<style lang="less" scoped>
.ucard-container {
  padding: 30px 50px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  background-image: url('~@/assets/imgs/home/banner2.png');
  background-repeat: round;
  background-size: cover;
  .ucard-container-card {
    display: flex;
    background-color: #fff;
    border-radius: 40px;
    padding: 50px 30px;
    .card-display {
      flex: 1;
      text-align: center;
      align-content: center;
      margin-right: 20px;
      .ucard-image {
        max-width: 100%;
        padding: 10px;
      }
    }
    .card-description {
      flex: 1;
      .network-info {
        .network-label {
          display: inline-block;
          padding: 4px 8px;
          background-color: #2052f3;
          color: #fff;
          border-radius: 16px;
          font-size: 14px;
        }
      }
      .title {
        font-size: 46px;
        font-weight: 400;
        margin: 30px 0;
      }
      .features {
        display: flex;
        flex-wrap: wrap;
        .feature-item {
          align-items: center;
          padding: 0 30px 40px 0;
          width: 50%;
          img {
            width: 30px;
          }
          .feature-content {
            .feature-title {
              font-size: 24px;
              font-weight: bold;
              padding: 10px 0;
            }
            .feature-detail {
              font-size: 18px;
              color: #666;
            }
          }
        }
      }
    }
  }
}
.ucard-container-two {
  min-height: 600px;
  background-color: #FFFFFF;
  .title {
    height: 200px;
    align-content: center;
    text-align: center;
    font-size: 28px;
  }

  .card-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 30px;
    gap: 100px;
    .card-one {
      background-image: url('~@/assets/imgs/home/discover.png');
      background-size: cover;
      color: #fff;
    }
    .card-two {
      background-image: url('~@/assets/imgs/home/masterCard.png');
      background-size: cover;
      color: #0c0c0c;
    }
    .card-item {
      position: relative;
      width: 560px;
      height: 350px;

    }
    .content {
      position: absolute;
      top: 180px;
      left: 70px;
      width: 420px;
      font-size: 18px;
    }
    h1 {
      position: absolute;
      top: 100px;
      left: 70px;
      font-size: 36px;
    }
  }
}

.card-container-three {
  min-height: 500px;
  background-color: #f2f4fa;
  .title {
    padding: 20px 0;
    align-content: center;
    text-align: center;
    font-size: 28px;
  }

  .features {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 0 50px 20px;
    .feature-item {
      border: 1px solid #e6e6e6;
      margin: 20px;
      .feature-content {
        padding: 20px;
        width: 440px;
        height: 156px;
        background-color: #fff;
        .feature-title {
          font-size: 24px;
          font-weight: bold;
        }
        .feature-detail {
          margin-top: 10px;
          font-size: 18px;
          color: #666;
        }
      }
    }
  }
}

.card-container-four {
  min-height: 500px;
  background-image: url('~@/assets/imgs/home/psbg.png');
  background-size: cover;
  padding-left: 100px;
  padding-top: 30px;
  .title {
    font-size: 28px;
    padding: 20px 0;
  }
  .feature-item {
    margin-bottom: 30px;
  }
  .item-img {
    width: 20px;
  }
  .feature-title {
    font-size: 20px;
    font-weight: bold;
  }
}
</style>


